/* @refresh reload */
import { render } from 'solid-js/web'
import { App } from '~/App'
import { setupAnalytics } from '~/lib/analytics'
import './index.css'

const root = document.getElementById('root')
if (!root) throw new Error('#root element not found')

render(() => <App />, root)

setupAnalytics()
